<template lang="pug">
  - $image_path = '@/assets/images/game/retry/';
  transition(name="fadein" appear)
    .view-retry(ref="page")
      CloseButton
      transition(name="slidein" appear)
        .frame
          .board(ref="board")
            .page-title
              p.page-title-text(ref="title"): img(src=`${$image_path}title.png`)
              .page-title-decoration-white(ref="titleDecoration")
                img(src=`${$image_path}title_decoration_white.png`)
              .page-title-decoration-yellow(ref="titleDecoration")
                img(src=`${$image_path}title_decoration_yellow.png`)
            .score
              p.score-number.number-sprite-s(
                v-for="num in scoreList"
                :class="`number-${num}`"
              )
              p.score-number.number-sprite-s.number-unit
          .charactor(ref="charactor"): img(src=`${$image_path}image_charactor.png`)
          .text(ref="text"): img(src=`${$image_path}text.png`)
          button.button-retry(ref="retry" @click="retry"): img(src=`${$image_path}button_retry.png`)
          .button-top(ref="top")
            router-link(:to="{ name:'top' }" @click.native="playSound('se_click_button')")
              img(src=`${$image_path}button_top.png`)
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap';
import { mapState } from 'vuex';

import CloseButton from '@/components/CloseButton';

import CountUp from '@/assets/js/CountUp';
import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';

export default {
  name: 'Retry',
  components: {
    CloseButton
  },
  data() {
    return {
      scoreCounter: null,
      scoreList: [0]
    };
  },
  computed: {
    ...mapState(['score'])
  },
  beforeDestroy() {
    SoundController.stopAll();
    this.scoreCounter.stop();
  },
  mounted() {
    this.startTimelineAnimation();
    const onRetryCountUp = () => {
      this.scoreCounter = new CountUp(this.score, count => {
        SoundController.play('se_add_score');
        this.scoreList = Utils.getNumberToList(count);
      });
    };
    Utils.addTimer({ key: 'retryCountUp', time: 1250 }, onRetryCountUp);
  },
  methods: {
    startTimelineAnimation() {
      const timeline = new TimelineMax();
      const zoom = (target, duration, animationTimeline) => {
        const halfDuration = duration * 0.5;
        animationTimeline
          .fromTo(
            target,
            halfDuration,
            { opacity: 0, transform: 'scale(0)' },
            { opacity: 0.5, transform: 'scale(1.5)' }
          )
          .to(target, halfDuration, { opacity: 1, transform: 'scale(1)' });
      };

      timeline
        .delay(0.5)
        .fromTo(
          this.$refs.board,
          0.5,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1 }
        );
      zoom(this.$refs.title, 0.5, timeline);
      timeline.fromTo(
        this.$refs.titleDecoration,
        0.5,
        { opacity: 0 },
        { opacity: 1 }
      );

      const charactorX = -this.$refs.charactor.clientWidth * 0.5;
      const charactorY = -this.$refs.charactor.clientWidth * 0.2;
      timeline.fromTo(
        this.$refs.charactor,
        0.25,
        { x: charactorX, y: charactorY, opacity: 0 },
        { x: 0, y: 0, opacity: 1 }
      );
      timeline.fromTo(
        this.$refs.text,
        0.25,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1 }
      );
      timeline.fromTo(
        this.$refs.retry,
        0.25,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1 }
      );
      timeline.fromTo(
        this.$refs.top,
        0.25,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1 }
      );
    },
    retry() {
      SoundController.play('se_click_button');
      this.$emit('onRetry');
    },
    playSound(key) {
      SoundController.play(key);
    }
  }
};
</script>

<style scoped lang="scss">
.view-retry {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background-image: image-url('game/retry/bg.png');
  background-size: 100% auto;
  .frame {
    position: relative;
    width: vw(1218);
    height: vw(1762);
    margin: vw(80) auto 0;
    background-image: image-url('game/retry/image_frame.png');
    background-size: contain;
    z-index: 0;
  }
  .board {
    position: absolute;
    top: vw(135);
    left: vw(110);
    width: vw(1000);
    height: vw(450);
    background-image: image-url('game/retry/image_score_frame.png');
    background-size: contain;
  }
  .page-title {
    position: absolute;
    top: vw(65);
    left: vw(83);
    &-text {
      width: vw(834);
    }
    &-decoration {
      &-white {
        position: absolute;
        top: vw(-48);
        left: vw(24);
        width: vw(727);
      }
      &-yellow {
        position: absolute;
        top: vw(-114);
        left: vw(-54);
        width: vw(863);
      }
    }
  }
  .score {
    display: flex;
    align-items: flex-end;
    position: absolute;
    top: vw(240);
    right: vw(210);
    z-index: 1;
    &-number {
      margin-left: vw(-18);
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .charactor {
    position: absolute;
    top: vw(592);
    left: vw(-30);
    width: vw(540);
    z-index: 1;
  }
  .text {
    position: absolute;
    top: vw(530);
    left: vw(320);
    width: vw(898);
    z-index: 0;
  }
  .button-retry {
    display: block;
    cursor: pointer;
    position: absolute;
    top: vw(1160);
    left: vw(151);
    width: vw(916);
    z-index: 1;
  }
  .button-top {
    position: absolute;
    top: vw(1460);
    left: vw(201);
    width: vw(816);
    z-index: 1;
    a {
      display: block;
    }
  }
  .number-sprite-s {
    background-image: image-url('game/number_s_spritesheet.png');
  }
}

.fadein-enter-active {
  transition: opacity 0.2s ease-in-out;
}
.fadein-enter {
  opacity: 0;
}
.fadein-enter-to {
  opacity: 1;
}
</style>
